import { useRef, useState } from "react";

export interface Marker {
  size?: "lg";
  seq: number;
  date: string;
  time: string;
  author: string;
  content: string;
}

interface MarkerDotProps {
  marker: Marker;
  onClick?: () => void;
  /** Marks the entry at the top of the feed (larger, with halo). */
  on?: boolean;
}

function preview(text: string, n = 8): string {
  if (!text) return "";
  const words = text.trim().split(/\s+/);
  return words.slice(0, n).join(" ") + (words.length > n ? "…" : "");
}

export function MarkerDot({ marker, onClick, on }: MarkerDotProps) {
  const [tip, setTip] = useState<{ top: number; left: number } | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  function show() {
    if (!ref.current) return;
    const r = ref.current.getBoundingClientRect();
    setTip({ top: r.top + r.height / 2, left: r.right + 12 });
  }
  function hide() { setTip(null); }

  return (
    <>
      <div
        ref={ref}
        role="button"
        tabIndex={0}
        className={`rail-ball${on ? " on" : ""}${marker.size === "lg" ? " lg" : ""}`}
        aria-label={`Log entry #${marker.seq}`}
        onMouseEnter={show}
        onFocus={show}
        onMouseLeave={hide}
        onBlur={hide}
        onClick={onClick}
      />
      {tip && (
        <div className="marker-tip" role="tooltip" style={{ top: tip.top, left: tip.left }}>
          <div className="marker-tip-head">
            <span className="marker-tip-seq">#{marker.seq}</span>
            <span className="marker-tip-ts">{marker.date}, {marker.time}</span>
          </div>
          <div className="marker-tip-author">{marker.author}</div>
          <div className="marker-tip-preview">{preview(marker.content, 8)}</div>
        </div>
      )}
    </>
  );
}
